import React from 'react';
import { IPaymentProvider } from 'src/components/store-payment/types';
import * as S from './styles';

const PaymentProviders: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPaymentProvidersProps>
>> = props => {
  return (
    <S.PaymentProviders>
      {props.providers.map(
        provider =>
          Boolean(provider.active) && (
            <img
              src={provider.logoUrl}
              alt={provider.label}
              title={provider.label}
              key={provider.name}
            />
          )
      )}
    </S.PaymentProviders>
  );
};

export default PaymentProviders;

interface IPaymentProvidersProps {
  providers: IPaymentProvider[];
}
